import Vue from "vue";
import router from "./router";
import accounting from "accounting";
import App from "./App-wc";
import store from "./store/index";
import layout from "./components/shared/layout.vue";
import FullLayout from "./components/shared/FullLayout.vue";
import mobileLayout from "./components/shared/mobileLayout.vue";
import VeeValidate from "vee-validate";
import { Validator } from "vee-validate";
import { ValidationProvider } from "vee-validate";
import { veeCustomMessage } from "./validation/dictionary";
import { DetectMobile } from "./mixins/detectmobile";
import { DetectWC } from "./mixins/wcDetector";
import { DetectVersion } from "./mixins/versionDetector";
import { DetectBrand } from "./mixins/brandDetector";
import { formatCard } from "./filters/formatCard";
import { urlify } from "./filters/urlify";
import { inputNameLocale } from "./filters/inputNameLocale";
import { camelCase } from "./filters/camelCase";
import { truncateText } from "./filters/truncateText";
import vueCustomElement from "vue-custom-element";
import "document-register-element/build/document-register-element";
import VueLazyload from "vue-lazyload";
import VueI18n from "vue-i18n";
import { veeCustomValidator } from "./validation/GeneralValidators";
import messages from "../lang/locale.json";
import { customValidations } from "./validation/validationHelper";
import { Bugfender } from '@bugfender/sdk';

customValidations(Validator);
Vue.use(VueI18n);
Vue.use(VueLazyload);
Vue.use(VueI18n);
Vue.mixin(DetectMobile);
Vue.mixin(DetectWC);
Vue.mixin(DetectVersion);
Vue.mixin(DetectBrand);

Vue.use(VeeValidate, {
  dictionary: veeCustomMessage,
  errorBagName: "OOErrors",
  mode: "lazy"
});
veeCustomValidator.init(VeeValidate);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("default-layout", layout);
Vue.component("full-layout", FullLayout);
Vue.component("mobile-layout", mobileLayout);
require("./assets/date-picker.scss");
require("./assets/google-pay.scss");
require("./assets/bootstrapwc/scss/bootstrap.scss");
require("./assets/main.scss");
require("./assets/main.mobile.scss");
require("jquery");
Bugfender.init({
  appKey: 'aJgMuctkrEEABvVH2EYZEfZdmDDWqbbI',
});

require("popper.js");
require("bootstrap");
Vue.config.productionTip = false;

Vue.filter("truncateText", truncateText);
Vue.filter("formatMoney", accounting.formatMoney);
Vue.filter("formatCard", formatCard);
Vue.filter("urlify", urlify);
Vue.filter("inputNameLocale", inputNameLocale);
Vue.filter("camelCase", camelCase);
Vue.filter("formatNumber", function (value) {
  return new Intl.NumberFormat().format(value);
});
Vue.use(vueCustomElement);
// Create VueI18n instance with options
const i18n = new VueI18n({
  messages // set locale messages
});
store.commit("setAvailableLocales", i18n.availableLocales);
i18n.locale = store.getters.selectedLocale;
App.store = store;
App.router = router;
App.i18n = i18n;
var shadowStyle = `
  .thisTemp1397IsRequired {
    background-color: blue;
}`;

Vue.customElement("oo-widget", App, {
  beforeCreateVueInstance(RootComponentDefinition) {
    document.getElementById = function (id) {
      var element = document.querySelector(id);

      var WC_Shadow = document.querySelector("oo-widget")
        ? document.querySelector("oo-widget").shadowRoot
        : null;

      if (WC_Shadow) {
        if (WC_Shadow.getElementById(id))
          element = WC_Shadow.getElementById(id);
      }
      return element;
    };

    return RootComponentDefinition;
  },
  vueInstanceCreatedCallback() {
    if (!this.shadowRoot) return;
    var that = this;

    let shadowCss = this.shadowRoot.querySelectorAll("style")[0];
    if (shadowCss) {
      document.head.querySelectorAll("link").forEach(function (item) {
        if (item.getAttribute("OO_Attr") === "OO_Module") {
          var link = document.createElement("link");
          link.href = item.getAttribute("href");
          link.type = "text/css";
          link.rel = "stylesheet";
          link.media = "screen,print";
          that.shadowRoot.appendChild(link);
        }
      });

      var findOOTag = false;

      document.head.querySelectorAll("style").forEach(function (item) {
        var innerText = item.innerText;
        if (
          innerText.match(/oo-module/) ||
          innerText.match(/vdp-datepicker/) ||
          innerText.match(/gpay/) ||
          innerText.match(/v-select/) ||
          (findOOTag &&
            (innerText.match(/Bootstrap/) ||
              innerText.match(/credit-card-field/)))
        ) {
          if (innerText.indexOf("oo-module")) findOOTag = true;
          shadowCss.appendChild(document.createTextNode(innerText));
        }
      });
    }
  },
  shadow: true,
  shadowCss: shadowStyle
});

new Vue({
  router: router,
  store,
  i18n,
  render: h => h(App)
});
